<template>
  <base-modal ref="modal" @hiding="reset()">
    <base-card shadow>
      <h3 class="tw-text-xl tw-font-thin tw-mb-5">Associate Location</h3>
      <base-form ref="form" v-model="isFormValid">
        <base-select
          label="Set Location"
          :options="sortedLocations"
          v-model="selectedLocationId"
          placeholder="Select a location"
          label-key="name"
          value-key="businessLocationId"
          required
        />
      </base-form>
      <inline-error id="assign-location-error" class="tw-my-3" :title="errorTitle" :message="errorMessage" :error="error" />
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button @click="saveLocation" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3">Save</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
    </base-card>
  </base-modal>
</template>

<script>
import { mapGetters } from "vuex";
import InlineError from "@/components/InlineError";

export default {
  name: "AssignLocation",
  components: { InlineError },
  props: {
    businessId: String,
  },
  data() {
    return {
      isLoading: false,
      isFormValid: true,
      selectedLocationId: null,
      todoItemId: null,
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  computed: {
    ...mapGetters("location", { locations: "locations" }),
    sortedLocations() {
      return this.locations.slice().sort((a, b) => a.name.localeCompare(b.name));
    },
  },
  created() {},
  methods: {
    show(todoItem) {
      this.todoItemId = todoItem.todoItemId;
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    reset() {
      this.selectedLocationId = null;
      this.errorTitle = "";
      this.errorMessage = "";
      this.error = null;
    },
    saveLocation() {
      if (!this.$refs.form.validate()) return;

      this.isLoading = true;

      this.$axios
        .put(`/businesses/${this.businessId}/todo/${this.todoItemId}`, {
          businessLocationId: this.selectedLocationId,
        })
        .then(() => {
          this.EventBus.$emit("GLOBAL_NOTIFY", {
            title: "Location Set",
            message: `Your activity was set to ${this.locations.find((x) => x.businessLocationId === this.selectedLocationId).name}.`,
          });
          this.EventBus.$emit("activitiesUpdated");
          this.reset();
          this.hide();
        })
        .catch((err) => {
          this.errorTitle = `Error setting location`;
          this.errorMessage = "Sorry, we had trouble setting the location for this activity. The technicians have been notified. Please try again.";
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
